import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import ColorBlock from "./ColorBlock";
import { Color } from "../../../../core/models/entities/LogoOptions";

function ColorSwitch({
  switchToColor,
  baseColor,
  isSelected,
  onClick,
  isBackup,
  isInDesignEditor,
}: {
  baseColor: Color;
  switchToColor?: Color;
  isSelected: boolean;
  onClick: (color: Color) => void;
  isBackup: boolean;
  isInDesignEditor?: boolean;
}) {
  function LabelText({
    color,
    hasTooltip,
  }: {
    color: Color;
    hasTooltip: boolean;
  }) {
    const displayName =
      isBackup && color.name === "Hvid"
        ? "Backup White"
        : color.nickname || color.name;
    const p = (
      <p className={"whitespace-nowrap overflow-hidden overflow-ellipsis"}>
        {displayName}
      </p>
    );

    return !hasTooltip ? (
      p
    ) : (
      <Tooltip placement={"top"} title={displayName}>
        {p}
      </Tooltip>
    );
  }

  // Tooltip content for backup colors
  const backupTooltip = isBackup
    ? "The application has assessed that one or more colors need Backup White as an extra layer for best color accuracy on all textiles."
    : undefined;

  const content = (
    <div
      onClick={() => !isBackup && onClick(baseColor)}
      className={`m-0.5 p-1 border rounded border-gray-200 h-[24px] flex items-center space-x-1.5 ${
        isBackup
          ? "cursor-not-allowed bg-gray-100 text-gray-400"
          : "cursor-pointer hover:border-gray-600"
      } ${isSelected ? "border-gray-600" : ""} ${
        isInDesignEditor ? "w-[150px]" : "w-[220px]"
      }`}
    >
      <ColorBlock color={baseColor} />
      {!!switchToColor ? (
        <>
          <FontAwesomeIcon size={"sm"} icon={faArrowRight} />
          <ColorBlock color={switchToColor} />
          <LabelText
            color={switchToColor}
            hasTooltip={
              (switchToColor.nickname || switchToColor.name).length > 5
            }
          />
        </>
      ) : (
        <LabelText
          color={baseColor}
          hasTooltip={(baseColor.nickname || baseColor.name).length > 5}
        />
      )}
    </div>
  );

  return backupTooltip ? (
    <Tooltip
      placement="top"
      title={<span className="text-xs">{backupTooltip}</span>}
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
}

export default ColorSwitch;
